import { render } from "./ShareIcons.vue?vue&type=template&id=07a7df74"
import script from "./ShareIcons.vue?vue&type=script&lang=js"
export * from "./ShareIcons.vue?vue&type=script&lang=js"

import "./ShareIcons.vue?vue&type=style&index=0&id=07a7df74&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__